export default __webpack_public_path__ + "static/media/allery-1.16b49d3f.svg";